module.exports = __webpack_public_path__ + "static/media/verifyEmail.c6b0ecc5.png";